import * as type from './practiceExamActionTypes';

export const setInitialTimePracticeExam = (time) => ({
  type: type.SET_INITIAL_TIME_PRACTICE_EXAM,
  time,
});

export const startTimerPracticeExam = (value) => ({
  type: type.START_TIMER_PRACTICE_EXAM,
  value,
});

export const stopTimerPracticeExam = () => ({
  type: type.STOP_TIMER_PRACTICE_EXAM,
});

export const updateTimerPracticeExam = () => ({
  type: type.UPDATE_TIMER_PRACTICE_EXAM,
});

/**
 * Loads the practice exam list: the weekly ones plus the custom exam status and history.
 */
export const getWeeklyPracticeExams = (onlyCustom = false) => ({
  type: type.GET_WEEKLY_PRACTICE_EXAMS,
  onlyCustom,
});

export const setCheckPracticeExamStatusLoading = (value) => ({
  type: type.SET_CHECK_PRACTICE_EXAM_STATUS_LOADING,
  value,
});

export const setCheckPracticeExamStatusFlag = (flag) => ({
  type: type.SET_CHECK_PRACTICE_EXAM_FLAG,
  flag,
});

export const setResultsSummarized = (results) => ({
  type: type.SET_RESULTS_SUMMARIZED,
  results,
});

export const startPracticeExam = (
  userPracticeExamId = null,
  practiceExamId = null,
  isCustom = false,
) => ({
  type: type.START_PRACTICE_EXAM,
  userPracticeExamId,
  practiceExamId,
  isCustom,
});

export const setReviewMode = (value) => ({
  type: type.SET_REVIEW_MODE,
  value,
});

export const setPracticeExamAvailable = (value) => ({
  type: type.SET_PRACTICE_EXAM_AVAILABLE,
  value,
});

export const getPracticeExamQuestions = (examId, isCustom = false) => ({
  type: type.GET_PRACTICE_EXAM_QUESTIONS,
  examId,
  isCustom,
});

export const setExamQuestions = (questions) => ({
  type: type.SET_EXAM_QUESTIONS,
  questions,
});
export const setPracticeExam = (exam) => ({
  type: type.SET_PRACTICE_EXAM,
  exam,
});

export const setNewDetail = (detail) => ({
  type: type.SET_NEW_DETAIL,
  detail,
});

export const updatePracticeExamResults = (
  examId,
  results,
  isCustom = false,
) => ({
  type: type.UPDATE_PRACTICE_EXAM_RESULTS,
  examId,
  results,
  isCustom,
});

export const submitPracticeExam = (examId, results, isCustom = false) => ({
  type: type.SUBMIT_PRACTICE_EXAM,
  examId,
  results,
  isCustom,
});

export const practiceExamResultsAction = (
  examId,
  retake,
  isCustom = false,
) => ({
  type: type.PRACTICE_EXAM_RESULTS,
  examId,
  retake,
  isCustom,
});

export const setSubmitPracticeExamSuccess = (value) => ({
  type: type.SET_SUBMIT_PRACTICE_EXAM_SUCCESS,
  value,
});

export const setSubmitPracticeExamLoading = (value) => ({
  type: type.SET_SUBMIT_PRACTICE_EXAM_LOADING,
  value,
});

export const isLoadingQuestionsPE = (isLoading) => ({
  type: type.IS_LOADING_PRACTICE_EXAM_QUESTIONS,
  isLoading,
});

export const setRetakeMode = (value) => ({
  type: type.SET_RETAKE_MODE,
  value,
});

// custom practice exam actions
export const generateCustomPracticeExam = (
  chapterIds,
  isRegeneration = false,
) => ({
  type: type.GENERATE_CUSTOM_PRACTICE_EXAM,
  chapterIds,
  isRegeneration,
});

export const setCustomPracticeExam = (value) => ({
  type: type.SET_CUSTOM_PRACTICE_EXAM,
  value,
});

export const setCustomPracticeExamStatus = (value) => ({
  type: type.SET_CUSTOM_PRACTICE_EXAM_STATUS,
  value,
});

export const getCustomPracticeExamReferences = (rateId) => ({
  type: type.GET_CUSTOM_PRACTICE_EXAM_REFERENCES,
  rateId,
});

export const setCustomPracticeExamReferences = (value) => ({
  type: type.SET_CUSTOM_PRACTICE_EXAM_REFERENCES,
  value,
});
export const setCustomPracticeExamReferencesLoading = (value) => ({
  type: type.SET_CUSTOM_PRACTICE_EXAM_REFERENCES_LOADING,
  value,
});

export const setCustomPracticeExamLoading = (value) => ({
  type: type.SET_CUSTOM_PRACTICE_EXAM_LOADING,
  value,
});

export const getCustomPracticeExamSettings = () => ({
  type: type.GET_CUSTOM_PRACTICE_EXAM_SETTINGS,
});

export const setCustomPracticeExamSettings = (value) => ({
  type: type.SET_CUSTOM_PRACTICE_EXAM_SETTINGS,
  value,
});

export const setCustomPracticeExamSettingsLoading = (value) => ({
  type: type.SET_CUSTOM_PRACTICE_EXAM_SETTINGS_LOADING,
  value,
});
